import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import type { ShipmentEmbryo } from '@/services/shipping/types';

import { RecaneEmbryosForm } from '../recane-embryos-form';
import { EmbryoFormValues } from '../recane-embryos-form/schema';

type RecaneEmbryosDialogProps = {
  visible: boolean;
  onHide: () => void;
  embryos?: ShipmentEmbryo[];
  existingCaneCodes?: string[];
  onSuccess?: (data: EmbryoFormValues) => void;
  onError?: (error: unknown) => void;
  'data-testid'?: string;
};

export const RecaneEmbryosDialog = ({
  visible,
  onHide,
  embryos,
  existingCaneCodes,
  onSuccess,
  onError,
  'data-testid': dataTestId,
}: RecaneEmbryosDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      header={t('embryo.recaneEmbryos')}
      visible={visible}
      onHide={onHide}
      modal
      className="w-[1000px] max-w-[95vw]"
      data-testid={dataTestId}
    >
      <div onClick={(e) => e.stopPropagation()}>
        <RecaneEmbryosForm
          embryos={embryos}
          existingCaneCodes={existingCaneCodes}
          onCancel={onHide}
          onSuccess={onSuccess}
          onError={onError}
        />
      </div>
    </Dialog>
  );
};
